<template>
  <!-- pc端页面：设计稿 1920×1080 -->
  <div class="page">
    <div class="stage">
      <div class="logo">
        <img src="@/assets/images/pc/index/logo.png" alt="星与" />
      </div>
      <div class="slogan">
        <img src="@/assets/images/pc/index/slogan.png" alt="找明星查代言 上星与" />
      </div>
      <div class="code">
        <img src="@/assets/images/pc/index/code.png" alt="星与小程序码" />
      </div>
      <div class="tip">扫码进入星与小程序</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PcHome', //首页
    data() {
      return {}
    },
    created() {
      this.setDocumentTitle('')
    },
    mounted() {},
    methods: {
      // 设置页面标题
      setDocumentTitle(title) {
        document.title = title + '星与'
      },
    },
  }
</script>

<style lang="scss" scoped>
  // 设计稿 1920×1080。背景铺满整屏且完整显示，元素按稿面比例定位，一屏内不滚动、不裁切。
  .page {
    position: fixed;
    inset: 0;
    overflow: hidden;
    background-image: url('@/assets/images/pc/index/bg.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    // background-size: 100% 100%;
  }

  .stage {
    position: absolute;
    inset: 0;

    img {
      display: block;
      // width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .logo {
    position: absolute;
    top: 5.277778%; // 57 / 1080
    left: 3.802083%; // 73 / 1920
    width: 6.770833%; // 130 / 1920
    height: 4.722222%; // 51 / 1080
  }

  .slogan {
    position: absolute;
    top: 27.333333%; // 306 / 1080
    left: 25.104167%; // 482 / 1920
    width: 22.1875%; // 426 / 1920
    height: 18.888889%; // 204 / 1080
  }

  .code {
    position: absolute;
    top: 50.166667%; // 541.8 / 1080
    left: 25.104167%; // 482 / 1920
    width: 9.776042%; // 187.7 / 1920
    height: 17.398148%; // 187.9 / 1080

    img {
      border-radius: 10.6%;
    }
  }

  .tip {
    position: absolute;
    top: 69.722222%; // 753 / 1080
    left: 25.104167%; // 482 / 1920
    width: 11.458333%; // 220 / 1920
    color: #ffffff;
    font-size: calc(24 / 1920 * 100vw);
    font-weight: 500;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
  }
</style>
